<template>

    <LoopItemPanel title="Item">

        <div class="canvas-blocks-sky-price-LoopItemPanel">

            <Tabs :tabs="[
                'Algemeen',
                'Design',
            ]">

                <div slot="Algemeen">

                    <SwitchInput
                        label="Is uitgelicht?"
                        :options="loopItem"
                        options-property="is_highlight"
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        defaultValue="0"
                        :open="true"
                    />

                    <SwitchInput
                        label="Toon extra tekst?"
                        :options="loopItem"
                        options-property="extra_text"
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        defaultValue="0"
                        :open="true"
                    />

                </div>

                <div slot="Design">

                    <accordion-input :open="true">
                        <template #label>

                            <div class="font-medium text-gray-600">Kleuren</div>

                        </template>
                        <template #content>

                            <ColorsInput
                                label="Achtergrondkleur van card"
                                instruction="Bepaal hier de kleur van de achtergrond van de huidige card."
                                :colors="colors"
                                :options="loopItem"
                                options-property="backgroundColor"
                                :accordion="false"
                                :spacing="{ 'horizontal': false, 'vertical': true }"
                            />

                            <ColorsInput
                                label="Tekstkleur van card"
                                instruction="Bepaal hier de kleur van de tekst van de huidige card."
                                :colors="colors"
                                :options="loopItem"
                                options-property="color"
                                :accordion="false"
                                :spacing="{ 'horizontal': false, 'vertical': true }"
                            />

                            <ColorsInput
                                label="Randkleur"
                                instruction="Bepaal hier de kleur van de rand van de huidige card."
                                :colors="colors"
                                :options="loopItem"
                                options-property="borderColor"
                                :accordion="false"
                                :spacing="{ 'horizontal': false, 'vertical': true }"
                            />

                        </template>
                    </accordion-input>
                </div>

            </Tabs>
        </div>
        
        <template v-slot:actionsExtra>
            <button class="btn btn-success" @click="save">
                <i class="mr-2 fas fa-check"></i> Opslaan
            </button>
        </template>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/LoopItemPanel";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import ColorsInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/ColorsInput";
import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";
import getDatabaseColors from "@galaxy/modules/Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors";

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
        SwitchInput,
        AccordionInput,
        Tabs,
        ColorsInput,
    },

    async mounted() {
        await this.loadColors();
    },

    data() {
        return {
            targets: {
                '_self': 'Huidige pagina',
                '_blank': 'Nieuwe pagina',
            },
            colors: null,
        };
    },

    methods: {

        async loadColors() {
            // Grab database colors
            let databaseColors = (await getDatabaseColors(true)).data;

            // Initialize empty array
            this.colors = [
                'transparent',
                'white',
                'black',
            ];

            // Add colors from database to array
            $.each(databaseColors, (item, value) => {
                if (typeof value !== 'string') {
                    this.colors.push(...Object.values(value));
                } else {
                    this.colors.push(value);
                }
            })

            this.colors = _.uniq(this.colors);

            let formattedColors = {};

            for (const color of this.colors) {
                if (typeof color === 'object') {
                    for (const [key, value] of Object.entries(color)) {
                        formattedColors[key] = value;
                    }
                } else {
                    formattedColors[color] = color;
                }
            }

            this.colors = formattedColors;
        },

    },

}
</script>
